export default ($element) => {
    if ($('#search-city').length < 1) {
        return false;
    }

    let $searchCity = $('#search-city');
    let $staticCityList = $('#city-list');
    let $searchResultList = $('#search-result-list');
    let $searchResult = $('#search-result');
    let $searchTermNotFound = $('.search-term-not-found');
    let $searchTerm = $('#search-term');
    let $searchType = $('#search-type');
    let $minimumSearchTermLength = 3;
    let serachType = 'Der Ort';

    $searchCity.on('input', function () {
        if (isNaN($searchCity.val().charAt(0))) {
            serachType = 'Der Ort';
            $minimumSearchTermLength = 3;
        } else {
            serachType = 'Die Postleitzahl';
            $minimumSearchTermLength = 2;
        }
        if ($searchCity.val().length >= $minimumSearchTermLength) {
            searchCity($searchCity.val());
            $searchTerm.text($searchCity.val());
            $searchType.text(serachType);
        } else {
            $searchResult.hide();
            $searchTermNotFound.hide();
            $searchResultList.empty();
            $staticCityList.show();
        }
    });

    let searchCity = debounce(function (searchTerm) {
        $.ajax({
            url: "/ajax/searchCityByName/" + searchTerm,
            xhrFields: {
                withCredentials: true
            }
        }).done(function(data) {
            showResults(data);
        });
    }, 125);

    function showResults(data) {
        $searchResultList.empty();

        if(data.length) {
            $staticCityList.hide();
            $searchTermNotFound.hide();
            data.map(function (item) {
                $searchResultList.append(getListItem(item));
            });
        } else {
            $staticCityList.show();
            $searchTermNotFound.show();
        }

        $searchResult.show();
    }

    function getListItem(item) {
        return `<li class="city-link" data-zipcode="${item.zipCode}">
                    <a href="/strompreisvergleich/stromanbieter-nach-staedten/${item.slug}">${item.zipCode} ${item.name} ${item.additional}</a>
                </li>`;
    }

    function debounce(func, wait, immediate) {
        let timeout;
        return function() {
            let context = this, args = arguments;
            let later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            let callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }
};
